import type { TFunction } from 'i18next';
import type { ProductType } from '../../payment.types';

export const getThankYouDescription = (productType: ProductType, t: TFunction) => {
  switch (productType) {
    case 'TreasuryProductBattlePass':
      return t("It's time to jump into your favorite games and unlock rewards!");
    case 'TreasuryProductXPBooster':
      return t('Your Reward Pass is now active. Enjoy enhanced progression in all your favorite games.');
    default:
      return t('Congratulations!');
  }
};
